import PropTypes from 'prop-types';
import Icon from "../../Icon/Icon";
import Phones from "../../../utils/Phones";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function PhoneNumbers(_ref) {
  let {
    phone_numbers = [],
    hideLabels = false,
    isInNetworkGroup = true,
    sortOrder = ['work', 'mobile', 'home', 'phone', 'fax', 'other', 'unknown'],
    detailedExtension = false
  } = _ref;
  const phoneNumbers = Phones.sortPhoneNumbers(phone_numbers, sortOrder);
  return phoneNumbers.map(phoneNumber => {
    const {
      extension = '',
      phone_type = '',
      phone_number = ''
    } = phoneNumber;
    const capitalized_phone_type = phone_type ? phone_type[0].toUpperCase() + phone_type.slice(1) : '';
    let numberText = !hideLabels && capitalized_phone_type ? `${capitalized_phone_type}: ` : '';
    numberText += Phones.formatPhoneNumber(extension ? phone_number + extension : phone_number, detailedExtension);
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("a", {
        href: Phones.getTelLink(phoneNumber, detailedExtension),
        target: "_blank",
        tabIndex: 0,
        rel: "noopener noreferrer",
        className: "rounded-sm focus:outline-solid-offset",
        title: numberText,
        children: [/*#__PURE__*/_jsx(Icon, {
          className: "align-middle",
          color: `${isInNetworkGroup ? 'action-blue' : 'brand-blue'}`,
          icon: "Phone"
        }), /*#__PURE__*/_jsx("span", {
          className: "align-middle pl-1 normal-case"
          // eslint-disable-next-line react/jsx-props-no-spreading
          ,
          ...(detailedExtension && {
            'data-test-element': 'client_phone_number'
          }),
          children: numberText
        })]
      })
    }, `phone-${phone_number}`);
  });
}
PhoneNumbers.propTypes = {
  hideLabels: PropTypes.bool,
  isInNetworkGroup: PropTypes.bool,
  phone_numbers: PropTypes.arrayOf(PropTypes.shape({
    phone_number: PropTypes.string,
    extension: PropTypes.string,
    phone_type: PropTypes.string
  })).isRequired,
  sortOrder: PropTypes.arrayOf(PropTypes.string),
  detailedExtension: PropTypes.bool
};
export default PhoneNumbers;
//# sourceMappingURL=PhoneNumbers.js.map